<!-- 
Contents of the HISTORY tab of the scheduled job page.
-->
<template>
  <div>
    <our-heading 
      :next-page-action="nextPageAction"
      :previous-page-action="previousPageAction"
      :arrived-from-listing="arrivedFromListing"
      :breadcrumbs="breadcrumbs"
      :title="title"
      user-guide-topic="administration-scheduled-jobs"
      module="scheduledJobs"
      nav-url="/scheduled-jobs/:id/history"
    />
    <tabs :scheduled-job-id="scheduledJobId" @changed="refresh">
      <our-search-button 
        :criteria="criteria" 
        :criteria-mutation="criteriaMutation" 
        :search-filters="searchFilters" 
        title="Search scheduled job history"
        flat
        show-all
        @changed="$refs.history.refresh()"
      />
      <our-saved-searches-menu
        :criteria="criteria"
        :criteria-mutation="criteriaMutation"
        :clear-criteria-mutation="clearCriteriaMutation"
        module="systemLogs" 
        color="primary"
        flat dense
        @selected="$refs.history.refresh()"
      />
      <system-log-listing 
        ref="history" 
        :endpoint="`/api/scheduled-jobs/${scheduledJobId}/history`" 
        :export-endpoint="`/api/exports/scheduled-jobs/${scheduledJobId}/history`"
        :export-validate-endpoint="`/api/exports/validate/scheduled-jobs/${scheduledJobId}/history`"
        embedded
      />
    </tabs>
  </div>
</template>

<script>
import SystemLogListing from "@/components/system-logs/SystemLogListing.vue";
import Tabs from "./Tabs.vue";
import scheduledJobMixins from "./mixins";
import * as mutation from "@/store/system-logs/mutation-types";
import { getSearchFilters } from "@/store/system-logs/helpers";

export default {
  name: "ScheduledJobHistory",
  components: { Tabs, SystemLogListing },
  mixins: [scheduledJobMixins],
  data() {
    return {
      criteriaMutation: mutation.LIST_SET_CRITERIA,
      clearCriteriaMutation: mutation.LIST_CLEAR_CRITERIA
    };
  },
  computed: {
    searchFilters() {
      return getSearchFilters("ScheduledJobAction", true);
    },
    criteria() {
      return this.$store.state.systemLogs.listing.criteria;
    }
  }
};
</script>
